import dot from 'dot-object';

import sheetConstants from '../data/sheetConstants';

import getRows from './getRows';

const falsyToUndefined = (value) => value || undefined;

const vendorSearchCriteria = (vendorId) => ({
    dataFilters: [{
        developerMetadataLookup: {
            metadataKey: 'id',
            metadataLocation: {
                sheetId: sheetConstants.vendorSheetId
            },
            metadataValue: vendorId
        }
    }]
});

const extractVendor = ([row]) => ({
    department: falsyToUndefined(row[3]),
    allowedReservationCount: parseInt(row[4]),
    contact: falsyToUndefined(row[2]),
    name: falsyToUndefined(row[1]),
    vendorId: row[0]
});

const reservationsByVendorIdSearchCriteria = (vendorId) => ({
    dataFilters: [{
        developerMetadataLookup: {
            metadataKey: 'vendorId',
            metadataLocation: {
                sheetId: sheetConstants.reservationsSheetId
            },
            metadataValue: vendorId
        }
    }]
});

const settingsSearchCriteria = () => ({
    dataFilters: [{
        gridRange: {
            sheetId: sheetConstants.settingsSheetId,
            startRowIndex: 0,
            endRowIndex: 200,
            startColumnIndex: 0,
            endColumnIndex: 2
        }
    }]
});

const extractSettings = (values) =>
    dot.object(values.reduce((accumulator, current) =>
        ({
            ...accumulator,
            [current[0]]: current[1]
        }), {}));

const reservationSearchCriteria = (reservationId) => ({
    dataFilters: [{
        developerMetadataLookup: {
            metadataKey: 'id',
            metadataLocation: {
                sheetId: sheetConstants.reservationsSheetId
            },
            metadataValue: reservationId
        }
    }]
});

const extractReservations = (rows) => rows.map((row) => ({
    email: falsyToUndefined(row[10]),
    firstName: falsyToUndefined(row[3]),
    lastName: falsyToUndefined(row[4]),
    organization: falsyToUndefined(row[0]),
    textField1: falsyToUndefined(row[5]),
    phone: falsyToUndefined(row[11]),
    textField2: falsyToUndefined(row[12]),
    address: falsyToUndefined(row[6]),
    city: falsyToUndefined(row[7]),
    state: falsyToUndefined(row[8]),
    zip: falsyToUndefined(row[9]),
    attendeeId: falsyToUndefined(row[2])
}));

const extractReservation = (rows) => {
    const [reservation] = extractReservations(rows);

    return reservation;
};

export const getVendor = async (sheetId, vendorId) => {
    const [result] = await getRows(sheetId, vendorSearchCriteria(vendorId), extractVendor);

    return result;
};

export const getSettings = async (sheetId) => {
    const [result] = await getRows(sheetId, settingsSearchCriteria(), extractSettings);

    return result;
};

export const getReservation = async (sheetId, reservationId) => {
    const [result] = await getRows(sheetId, reservationSearchCriteria(reservationId), extractReservation);

    return result;
};

export const getReservationsByVendorId = async (sheetId, vendorId) => {
    const reservations = await getRows(sheetId, reservationsByVendorIdSearchCriteria(vendorId), extractReservations);

    return reservations.reduce((accumulator, current) => [...accumulator, ...current], []);
};




// WEBPACK FOOTER //
// ./src/data/get-from-sheet.js